import {z} from 'zod';

/**
 * Standard Option type schema used across the application
 * Represents a selectable option with a human-readable label and a machine-readable value
 */
export const optionItemSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export type OptionItem = z.infer<typeof optionItemSchema>;
